import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import formatMoney from 'utils/formatMoney'
import { useSelector } from 'react-redux'
import Placeholder from 'modules/Finance/Wallets/subcomponents/WalletHeader/subcomponents/Placeholder'
import { useWallets } from 'modules/Finance/Wallets'
import EditableField from 'components/EditableField'

const WalletHeader = () => {
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const { setWalletName } = useWallets()
  const { activeWalletID, wallets: { data: wallets = [], loaded = false } = {} } = useSelector(
    (state) => state['finance/wallets'],
  )

  const {
    currency,
    balance = null,
    name,
    financial_profile: { financial_profile_type: { type = null } = {} } = {},
  } = useMemo(
    () => wallets?.find(({ id }) => id === +activeWalletID) ?? {},
    [wallets, activeWalletID],
  )

  const applyWalletName = useCallback(
    (walletID, name) =>
      new Promise((resolve, reject) =>
        setWalletName({ walletID, name, meta: { resolve, reject } }),
      ),
    [],
  )

  if (!activeWalletID || !loaded) {
    return <Placeholder />
  }

  return (
    <>
      <div className={'margin-bottom-16'}>
        <EditableField
          name={name ?? t('wallets::nav.my_account')}
          id={activeWalletID}
          apply={applyWalletName}
          placeholder={t('wallets::list.name.placeholder')}
        >
          <Typography
            variant={'Body-Accent-30'}
            color={'Label-Fifth'}
            component={'h3'}
          >
            {name ?? t('wallets::nav.my_account')}
          </Typography>
        </EditableField>
      </div>
      <Typography
        component={'div'}
        noMargin
        variant={'Body-Accent-80'}
        className={breakpoint.sm ? 'margin-bottom-24' : 'margin-bottom-40'}
        dangerouslySetInnerHTML={{
          __html: formatMoney(balance, currency),
        }}
      />

      {!['partner', 'ad-tax-hold'].includes(type) && (
        <Grid
          gap={16}
          alignItems={'start'}
          justifyContent={'start'}
        >
          <Col flexGrow={!breakpoint.sm ? 1 : 0}>
            <Button
              fullWidth={!breakpoint.sm}
              component={Link}
              to={pathGen(ROUTES.BILLING_TOP_UP)}
              size={'l'}
              variant="primary"
              startIcon={<Icon name="card" />}
            >
              {t('common::buttons.add_funds')}
            </Button>
          </Col>

          <Button
            component={Link}
            to={ROUTES.FINANCE_PROMISED_PAYMENT}
            size={'l'}
            variant={'secondary'}
            startIcon={<Icon name="orders" />}
            noLabel={!breakpoints.xxl}
          >
            {t('common::buttons.promised_payment')}
          </Button>
        </Grid>
      )}
    </>
  )
}

WalletHeader.propTypes = {}

export default WalletHeader
